import React from 'react';

import {assert} from 'Asserts';
import {getRegistrySupportedOligoAwareTypes, TagSchema} from 'constants/RegistryConstants';
import {tagSchemaHasNoContainableType} from 'constants/SampleConstants';
import TagSchemaSelector from 'schemas/shared/TagSchemaSelector';
import {FilterKey, SingleValueFilter} from 'search/SearchConstants';
import APIUtil from 'util/APIUtil';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';
import {ParentTypeOption} from './ContainerParentFilterForm';

interface ContainerContentSchemaFilter extends SingleValueFilter {
  key: FilterKey.CONTAINER_CONTENT_SCHEMA;
}
interface Props extends BaseFilterFormProps {
  filter: ContainerContentSchemaFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: ContainerContentSchemaFilter) => void;
  onRemove: () => void;
}
interface State {
  desiredParentType: ParentTypeOption;
}
export default class ContainerContentSchemaFilterForm extends React.Component<Props, State> {
  handleParentBioentitySchemaChange = (tagSchema: TagSchema | null): void => {
    assert(tagSchema != null, 'TagSchemaSelector returned a null tag schema');
    this.props.onChangeFilter({...this.props.filter, value: tagSchema.id});
  };

  renderInputForParentType(): JSX.Element {
    const parentType = this.props.filter.value;
    assert(
      !parentType || (APIUtil.apiIdToType(parentType) as string) !== ParentTypeOption.BIOENTITY_SCHEMA,
      `Unexpected parentType: ${parentType}`
    );
    return (
      <div className="u-flex-grow">
        <TagSchemaSelector
          oligoAwareFolderItemTypes={getRegistrySupportedOligoAwareTypes()}
          isTagSchemaDisabledFn={tagSchemaHasNoContainableType}
          disabledMessage="Not containable"
          onChange={this.handleParentBioentitySchemaChange}
          selectedTagSchemaId={parentType}
        />
      </div>
    );
  }

  render(): JSX.Element {
    assert(
      this.props.filterStyle === FilterStyle.SECONDARY,
      'Content type filter is only configured to work as a secondary filter'
    );
    return (
      <SecondaryFilterFormSkeleton
        {...pickDefined(this.props, ...BASE_FILTER_FORM_PROP_NAMES)}
        nodeGrid={[[this.renderInputForParentType()]]}
        onChangeFilterKey={this.props.onChangeFilterKey}
        selectedFilterKey={this.props.selectedFilterKey}
        onRemove={this.props.onRemove}
      />
    );
  }
}
